import { defineMessages } from 'react-intl';

export default defineMessages({
  confirm: {
    id: 'button.confirm',
    defaultMessage: '确认',
  },
  sure: {
    id: 'button.sure',
    defaultMessage: '确定',
  },
  cancel: {
    id: 'button.cancel',
    defaultMessage: '取消',
  },
  submit: {
    id: 'button.submit',
    defaultMessage: '提交',
  },
  iknown: {
    id: 'button.iknown',
    defaultMessage: '我知道了',
  },
  receiveWelfare: {
    id: 'button.receiveWelfare',
    defaultMessage: '领取福利',
  },
  known: {
    id: 'button.known',
    defaultMessage: '知道了',
  },
  close: {
    id: 'button.close',
    defaultMessage: '关闭',
  },
  finish: {
    id: 'button.finish',
    defaultMessage: '完成',
  },
  buyNow: {
    id: 'button.buyNow',
    defaultMessage: '去购买',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/button/index.js